module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 1786
// module chunks = 0